import React from "react";
import { Divider } from "@/components";
import { formatCurrency } from "@/lib/currency/currency";
import { Modal } from "react-bootstrap";
import { colors } from "@/offering_v2/components/colors";
import { getSystemLocale } from "@/lib/locale/locale";
import { MembershipPriceInfo } from "@/offering_v2/components/membership_price_info";
import { isNumber } from "lodash";
import { FeeLine } from "@/offering/api";

interface PortalBillBreakdownModalProps {
  show: boolean;
  onHide: () => void;
  totalAmount: number;
  currency: string;
  monthlyPaymentAmount: number;
  taxDescription?: string | null;
  taxAmount: number;
  promotionCode?: string | null;
  promotionAmount: number;
  isRefunded?: boolean;
  /**
   * if `paymentCycles > 0`,  it shows "First `paymentCycles + 1` months payment",
   * else "Monthly payment"
   */
  paymentCycles: number;
  adjustmentAmount: number;
  refundedAmount?: number | null;
  feeLines?: FeeLine[];
}

export function PortalBillBreakdownModal({
  show,
  onHide,
  totalAmount,
  currency,
  monthlyPaymentAmount,
  taxAmount,
  taxDescription,
  promotionAmount,
  promotionCode,
  isRefunded,
  paymentCycles,
  adjustmentAmount,
  refundedAmount,
  feeLines,
}: PortalBillBreakdownModalProps) {
  const minimumFractionDigits = 2;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="header-center"
      fullscreen="sm-down"
    >
      <Modal.Header closeButton>
        <Modal.Title as="b">Total bill breakdown</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div className="mb-3">
            <MembershipPriceInfo
              firstMonthAdjustment={adjustmentAmount}
              currency={currency}
              monthlyPrice={monthlyPaymentAmount}
              promotion={
                promotionCode
                  ? { amount: promotionAmount, code: promotionCode }
                  : null
              }
              taxLine={
                taxDescription
                  ? { description: taxDescription, amount: taxAmount }
                  : null
              }
              paymentCycles={paymentCycles}
              feeLines={feeLines}
              feeLinesDisplay="list"
            />
          </div>

          <Divider />
          <div className="d-flex justify-content-between mt-3">
            <b>Total bill</b>
            <b>
              {formatCurrency(
                totalAmount,
                currency,
                getSystemLocale(),
                minimumFractionDigits
              )}
            </b>
          </div>
          {isRefunded && isNumber(refundedAmount) && (
            <div
              className="d-flex justify-content-between mt-3"
              style={{ color: colors.spinachCore }}
            >
              <span>Refunded</span>
              <span>
                {formatCurrency(
                  -refundedAmount,
                  currency,
                  getSystemLocale(),
                  minimumFractionDigits
                )}
              </span>
            </div>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}
